import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import FormRender from 'modules/forms/components/FormRender'

type Data = {
  formId: string
  membershipId: string
  resourceType: string
}

export const AnswerFormActivity: ActivityComponent<Data> = ({
  formId,
  membershipId,
  resourceType,
}) => {
  const { open, closeActivity } = useActivity()

  return (
    <FormRender
      formId={formId}
      resourceType={resourceType}
      isOpen={open}
      onClose={closeActivity}
      onSubmitSuccess={closeActivity}
      mode="answer"
      membershipId={membershipId}
    />
  )
}
